import { cn } from '@/lib/utils';

interface LoadingLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_MAP = {
  sm: { mark: 28, dot: 16, lineWidth: 16, lineHeight: 3, offset: 4 },
  md: { mark: 32, dot: 20, lineWidth: 20, lineHeight: 4, offset: 5 },
  lg: { mark: 40, dot: 24, lineWidth: 24, lineHeight: 4, offset: 6 },
} as const;

export function LoadingLogo({
  size = 'md',
  className,
}: LoadingLogoProps): JSX.Element {
  const dims = SIZE_MAP[size];

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className={cn('loading-logo flex items-center justify-center', className)}
    >
      <div
        className="loading-logo-mark relative"
        style={{
          width: dims.mark,
          height: dims.mark + 4,
        }}
      >
        <div
          className="loading-logo-dot absolute rounded-full"
          style={{
            width: dims.dot,
            height: dims.dot,
            top: 0,
            left: dims.offset,
          }}
        />
        <div
          className="loading-logo-line absolute rounded-full"
          style={{
            width: dims.lineWidth,
            height: dims.lineHeight,
            bottom: 0,
            left: dims.offset,
          }}
        />
      </div>
    </div>
  );
}
